import { Component } from '@angular/core';

@Component({
  selector: 'tun-cd-icon',
  templateUrl: './cd-icon.component.html'
})
export class CdIconComponent { }
